import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const searchApi = {
  search: (params) => api.get('/search', { params }).then(unwrap),
  listSaved: () => api.get('/search/saved').then(unwrap),
  saveFilter: (payload) => api.post('/search/saved', payload).then(unwrap),
  deleteSaved: (id) => api.delete(`/search/saved/${id}`).then(unwrap),
};
